
export function getParams() {
    const _raw = window.location.search || "";
    const raw = _raw.startsWith("?") ? _raw.slice(1) : _raw;
    if(!raw) return {};

    const rawArr = raw.split("&");
    const values = {};
    for(const paramRaw of rawArr) {
        const [name, encodedValue] = paramRaw.split("=");
        const value = decodeURIComponent(encodedValue);

        values[name] = value;
    }

    return values;
}

export function encodeParams(values) {
    return new URLSearchParams(values).toString();
}